module.exports = __webpack_public_path__ + "img/3.a7090ee9.png";